//apple确认登录弹出
import appleConfirmLogin from "../components/appleConfirmLogin.vue";
import { createApp } from "vue";
export const showLConfirmLoginDialog = (): Promise<"success" | "cancel"> => {
  return new Promise((reslove, reject) => {
    try {
      const mountNode = document.createElement("div");
      mountNode.id = "confirm-login-dialog";
      document.body.appendChild(mountNode);
      const app = createApp(appleConfirmLogin, {
        closeCb: () => {
          app.unmount();
          document.body.removeChild(mountNode);
        },
      });
      app.mount(mountNode);
      reslove("success");
    } catch (err) {
      reject(err);
    }
  });
};
